import { Component } from '@angular/core';

@Component({
  selector: 'app-apisalinty-vertical-header',
  standalone: false,
  templateUrl: './apisalinty-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class ApisalintyVerticalHeaderComponent {


}
